export const GET_CURRENT_MANUFACTURER__REQUEST = 'PROFILE_TYPE__GET_CURRENT_MANUFACTURER__REQUEST'
export const GET_CURRENT_MANUFACTURER__SUCCESS = 'PROFILE_TYPE__GET_CURRENT_MANUFACTURER__SUCCESS'
export const GET_CURRENT_MANUFACTURER__FAILURE = 'PROFILE_TYPE__GET_CURRENT_MANUFACTURER__FAILURE'